export default {
  notFound: 'Menu not found',
  MenuUpdated: 'Menu updated',
  OpenIn: 'Open in',
  SamePage: 'Same page',
  NewPage: 'New page',
  CssClass: 'CSS class',
  Component: 'Component',
  Everyone: 'Everyone',
  Authenticated: 'Authenticated',
  Unauthenticated: 'Unauthenticated',
  EnterTitleOrIcon: 'Every item must have at least title or icon'
}
